import { LoginParticipante } from './../../models/login-participante.model';
import { LoginService } from './../../services/login-participante.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../../services/storage.service';


@Injectable({
  providedIn: 'root'
})

export class TermoGuardService implements CanActivate {

  constructor(
    protected storage: StorageService,
    protected route: Router,
    protected loginServices: LoginService) { }

    participante: LoginParticipante = new LoginParticipante();
 
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    //console.log("passou pela garda de termo")
    if (sessionStorage.getItem('termoAceite') == 'aceito')   {     
      return true;
    } else {
      this.route.navigate(['/termo']);
      return false;
    }
  }


  
}
